<script setup lang="ts">
import CheckCircleFilledSVG from '@shared/assets/icon/check-circle-filled.svg';

interface Props {
  modelValue: boolean;
  ariaLabel: string;
  dataTn?: string;
  name?: string;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<template>
  <label class="check-wrap">
    <input
      type="checkbox"
      :checked="modelValue"
      @change="handleChange"
      :data-tn="dataTn ? `${dataTn}-input` : undefined"
      :aria-label="ariaLabel"
      :name="name"
    />
    <span class="checkbox" aria-hidden="true" :data-tn="dataTn">
      <CheckCircleFilledSVG v-if="modelValue" />
    </span>
  </label>
</template>

<style lang="less" scoped>
.check-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;

  .checkbox {
    width: 30px;
    height: 30px;
    border: 2px solid @color-primary;
    border-radius: 50%;
    display: inline-block;
    background-color: white;
  }

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:focus + .checkbox {
    box-shadow: 0 0 0 2px fade(@color-primary, 20%);
  }

  input:checked + .checkbox {
    border: 0px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;

    :deep(svg) {
      color: @color-primary;
    }
  }
}
</style>
